import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { FcpAlertModule, FcpButtonModule, FcpIconModule } from 'fc-ui-components';
import { FcpRadiobuttonComponent, FcpToggleSwitchComponent } from 'fc-design-system';
import { SharedModule } from 'shared/shared.module';
import { SidebarModule } from '../../../../components';
import { ResponsiveWrapperModule } from '../../../../components/responsive-wrapper/responsive-wrapper.module';
import { BulkGtinSearchComponent } from './bulk-search.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule,
        FcpIconModule,
        FcpAlertModule,
        FcpButtonModule,
        FcpToggleSwitchComponent,
        SharedModule,
        MatSidenavModule,
        MatCheckboxModule,
        SidebarModule,
        FormsModule,
        ReactiveFormsModule,
        ResponsiveWrapperModule,
        FcpRadiobuttonComponent
    ],
    declarations: [BulkGtinSearchComponent],
    exports: [BulkGtinSearchComponent]
})
export class BulkGtinSearchModule {}
